import { Button, message } from "antd"
import React from "react"
import { CopyToClipboard } from "react-copy-to-clipboard"

const EtlDirMenu = ({
  setShowUpload,
  showUpload,
  currentPath,
}: {
  setShowUpload: any
  showUpload: boolean
  currentPath: string
}) => {
  return (
    <div
      style={{
        // height: "35px",
        margin: "10px 0",
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: "#e5e3e3",
        padding: 4,
        borderRadius: 5,
      }}
    >
      <CopyToClipboard
        text={currentPath || "/"}
        onCopy={() => message.success("Path copied to clipboard")}
      >
        <Button type={"link"}>Copy path</Button>
      </CopyToClipboard>

      <div style={{ flexDirection: "row-reverse" }}>
        <Button
          onClick={() => setShowUpload(!showUpload)}
          type={"primary"}
          danger={showUpload}
        >
          {showUpload ? "Hide" : "Show"} Upload
        </Button>
      </div>
    </div>
  )
}

export default EtlDirMenu
